// src/components/FormationSideBartreeView.jsx (avec gestion des privilèges)
import React, { useState, useEffect, useContext } from "react";
import TreeView from "@material-ui/lab/TreeView";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { useLocation } from "react-router-dom";
import { Divider } from "@material-ui/core";

import StyledTreeItem from "./StyledTreeItem";
import useStyles from "./styledtreeitem.styles";
import { userDetailContext } from "../App";
import PlanningService from "../services/PlanningService";
import { hasPrivilege } from "../utils/privilege";

// Icônes
import HomeIcon from "@material-ui/icons/Home";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import BarChartIcon from "@material-ui/icons/BarChart";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import PersonIcon from "@material-ui/icons/Person";
import ChevronRight from "@material-ui/icons/ChevronRight";

function FormationSideBartreeView() {
  const classes = useStyles();
  const contextData = useContext(userDetailContext);
  const location = useLocation();
  const { pathname } = location;

  const [id, setId] = useState(0);
  const [idSupSpecial, setIdSupSpecial] = useState(0);
  const [showTitlePreProd, setShowTitlePreProd] = useState(false);

  useEffect(() => {
    PlanningService.getUser().then((result) => {
      if (result) {
        setId(result.data);
        setIdSupSpecial(result.dataSpecial);
      }
    });

    if (window.location.hostname === "2fidmg.mg") {
      setShowTitlePreProd(true);
    }
  }, []);

  // Gestion localStorage pour l'expansion des menus
  const getInitialExpanded = () => {
    const stored = localStorage.getItem("FORMATION_EXPANDED");
    if (stored && stored.length > 0) {
      return stored.split(",");
    }
    return ["1", "2", "3"];
  };

  const [expanded, setExpanded] = useState(getInitialExpanded());

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
    localStorage.setItem("FORMATION_EXPANDED", nodeIds.join(","));
  };

  const handleExpandClickCours = () => {
    setExpanded((oldExpanded) =>
      oldExpanded.includes("1") ? oldExpanded.filter(id => id !== "1") : [...oldExpanded, "1"]
    );
  };

  const handleExpandClickResultats = () => {
    setExpanded((oldExpanded) =>
      oldExpanded.includes("2") ? oldExpanded.filter(id => id !== "2") : [...oldExpanded, "2"]
    );
  };

  const handleExpandClickLabellisation = () => {
    setExpanded((oldExpanded) =>
      oldExpanded.includes("3") ? oldExpanded.filter(id => id !== "3") : [...oldExpanded, "3"]
    );
  };

  const splitLocation = pathname.split("/");

  // Style pour les conteneurs de menu
  const menuItemStyle = {
    marginBottom: "16px",
    borderRadius: "8px",
    transition: "all 0.3s ease"
  };

  const dividerStyle = {
    margin: "16px 8px",
    backgroundColor: "#E0E0E0"
  };

  return (
    <>
      {showTitlePreProd && (
        <h2 style={{ color: "red", fontWeight: "bold", padding: "10px", textAlign: "center", fontSize: "14px" }}>
          SERVEUR TEST
        </h2>
      )}

      <TreeView
        className={classes.treeView}
        defaultExpanded={["1", "2", "3"]}
        defaultCollapseIcon={<ArrowDropDownIcon />}
        defaultExpandIcon={<ArrowRightIcon />}
        expanded={expanded}
        onNodeToggle={handleToggle}
        defaultEndIcon={<div style={{ width: 24 }} />}
        style={{ 
          whiteSpace: "normal", 
          wordWrap: "break-word", 
          padding: "16px 8px",
          display: "flex",
          flexDirection: "column",
          gap: "20px"
        }}
      >
        {/* Section 1: Accueil */}
        <div style={menuItemStyle}>
          <StyledTreeItem
            nodeId="0"
            labelText="Accueil"
            labelIcon={HomeIcon}
            link="/formation"
            isBold={true}
            isActiveMenu={pathname === "/formation"}
          />
        </div>


        {/* Section 2: Parcours */}
        <div>
          <div style={menuItemStyle}>
            <StyledTreeItem
              nodeId="1"
              labelText="Mes cours"
              labelIcon={MenuBookIcon}
              isBold={true}
               link="/formation/cours"
              onClick={handleExpandClickCours}
              isActiveMenu={pathname === "/formation/cours"}
            />
          </div>

          {/* <div style={menuItemStyle}>
            <StyledTreeItem
              nodeId="2"
              labelText="Mes résultats"
              labelIcon={BarChartIcon}
              isBold={true}
              link="/formation/resultats"
              onClick={handleExpandClickResultats}
              isActiveMenu={pathname === "/formation/resultats"}
            />
          </div>

          <div style={menuItemStyle}>
            <StyledTreeItem
              nodeId="3"
              labelText="Évaluation"
              labelIcon={EmojiEventsIcon}
              isBold={true}
               link="/formation/labellisation"
              onClick={handleExpandClickLabellisation}
              isActiveMenu={pathname === "/formation/labellisation"}
            />
          </div> */}
        </div>

      </TreeView>
    </>
  );
}

export default FormationSideBartreeView;